import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import {UserContext} from "../common/UserContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import {BrandContext} from "../common/BrandContext";
import ListItemTrail from "../common/ListItemTrail";
import Button from "../common/Button";
import ButtonsGroup from "../common/ButtonsGroup";
import ButtonSelect from "../common/ButtonSelect";
import GoToButtonSection from "../components/GoToButtonSection";

const TeacherTrailsDashboardWidget = props => {
    const {...other} = props;
    const brandConfig = useContext(BrandContext);
    const {user, setUser} = useContext(UserContext);
    const [trails, setTrails] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const {loadShortcutByUrl} = useCurrentShortcut();
    const [assigned, setAssigned] = useState('');
    const [assignTypes, setAssignTypes] = useState([
        {value: '', label: 'All'},
        {value: true, label: 'Assigned'},
        {value: false, label: 'Not assigned'}
    ]);

    useEffect(() => {
        setLoading(true);
        if (assigned !== undefined) {
            let params = assigned !== '' ? {params: {assigned: assigned}} : {};
            axios.get('/web/ui/trail/dashboardTeacherTrails', params)
                .then(response => {
                    setTrails(response.data);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [assigned]);

    const handleOwnerChange = selectedOption => {
        if (selectedOption.value !== undefined) setAssigned(selectedOption.value);
    }

    const createTrailFromDashBoard = () => {
        globalReactFunctions.createTrailFromDashboard = true;
        loadShortcutByUrl('/web/ui/view/teacherTrails');
    }

    return (
        <>
            {brandConfig.use2025Dashboard &&
                <h2>{brandConfig.tasksName}</h2>
            }
            <DashboardWidget
                title={!brandConfig.use2025Dashboard ?
                    <>
                        <div className="ch-dashboard-title-with-icon">
                            <svg className="ch-icon-medium" viewBox="0 0 128 128">
                                <use href="#pathways-icon"></use>
                            </svg>
                            <span>{brandConfig.tasksName}</span>
                        </div>
                    </>
                    : null
                }
                isLoading={isLoading}
                headerActions={
                    <ButtonsGroup>
                        <Button onClick={createTrailFromDashBoard} disabled={user.schoolId == null || user.limitedProduct}>
                            {'Create ' + brandConfig.taskName}
                        </Button>
                        <ButtonSelect title="Type" type="outline" options={assignTypes} value={assignTypes[0]} onChange={handleOwnerChange} />
                    </ButtonsGroup>
                }
                {...other}>
                <div className={'ch-dashboard-blk-body'}>
                    {trails.length > 0 &&
                        trails.map((trail) => (
                                <ListItemTrail key={trail.pathwayId} trail={trail} user={user}/>
                            ))
                    }
                    {trails.length == 0 &&
                        <div className="ch-list-item-disabled">No tasks available</div>
                    }
                </div>
                <GoToButtonSection buttonText={'Go to all my ' + brandConfig.tasksName.toLowerCase()}
                                   onClick={() => loadShortcutByUrl('/web/ui/view/teacherTrails')}
                                   disabled={user.schoolId == null || user.limitedProduct}/>
            </DashboardWidget>
        </>
    )
}

export default TeacherTrailsDashboardWidget;